
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BarChart4 } from 'lucide-react';

const BusinessCTA: React.FC = () => {
  return <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl p-8 text-white">
      <div className="md:flex items-center justify-between">
        <div className="mb-6 md:mb-0">
          <h3 className="text-2xl font-bold mb-2">Ready to Start Your Referral Business?</h3>
          <p className="text-white/80">$499 setup fee gets you started with access to 300 client accounts. Earn recurring revenue with our revenue sharing model.</p>
        </div>
        <Link to="/business-reseller-order">
          <Button size="lg" variant="default" className="bg-white text-blue-600 hover:bg-gray-100 rounded-xl">
            Sign-Up Now <BarChart4 className="ml-2 h-5 w-5" />
          </Button>
        </Link>
      </div>
    </div>;
};

export default BusinessCTA;
